import { render, staticRenderFns } from "./CAVE.vue?vue&type=template&id=15a9ac1d&scoped=true&"
import script from "./CAVE.vue?vue&type=script&lang=js&"
export * from "./CAVE.vue?vue&type=script&lang=js&"
import style0 from "./CAVE.vue?vue&type=style&index=0&id=15a9ac1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9ac1d",
  null
  
)

export default component.exports